import { useMutation, useQueryClient } from 'react-query'
import { newUserPassword } from 'api/services/user'

export const useNewUserPassword = (options = {}) => {
  const queryClient = useQueryClient()
  const { onSuccess = () => {} } = options

  return useMutation((data) => newUserPassword(data), {
    ...options,
    onSuccess: (data) => {
      queryClient.invalidateQueries('users')
      onSuccess(data)
    },
  })
}
